export default __webpack_public_path__ + "static/media/Flag_of_Croatia.6cfb03e5.svg";